import { memo } from 'react'
import Alert from 'react-bootstrap/Alert'

import localStorageService from '@/services/localStorage.service'
import { FilterType } from '@/types/additionalFilters'

type Props = {
  filters: FilterType[]
  groupedBy?: string
  loading: boolean
  sortedBy?: string
}

const CardListAlerts = ({ filters, groupedBy, loading, sortedBy }: Props) => {
  const showPriceAlert =
    localStorageService.get('priceAlertDismissed') !== 'true' &&
    (groupedBy === 'price' || sortedBy === 'price' || filters.some((row) => row.key === 'price'))

  return (
    !loading &&
    showPriceAlert && (
      <div className='d-flex justify-content-center m-2'>
        <Alert dismissible onClose={() => localStorage.setItem('priceAlertDismissed', 'true')}>
          Note: <i>price</i> is from the first (left-most) price source in your settings
        </Alert>
      </div>
    )
  )
}

export default memo(CardListAlerts)
